import Head from 'next/head'

import SheetTitle from 'components/Sheet/SheetTitle'
import Sheet from 'components/Sheet/Sheet'
import SheetContainer from 'components/Sheet/SheetContainer'

const Analytics = ({  }) => {
  return (
    <SheetContainer>
      <Head>
        <title>Portfolio Analytics - SIMM</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <SheetTitle>Sector Diversification</SheetTitle>
      <Sheet 
        className="iframe-placeholder"
        height='620' 
        width='620'
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQvQUQBDggQT4_HXyzT8Zo74JUF8cGkRlHkPmYPxBuM1xa1x42PNg0bn30sqIyuf9dv002HeAzv0Tq-/pubhtml?gid=1230297165&amp;single=true&amp;widget=true&amp;headers=false&amp;chrome=false&amp;rm=minimal"
      />
      
      <SheetTitle>Size/Style Diversification</SheetTitle>
      <Sheet 
        className="iframe-placeholder"
        height='630' 
        width='620'
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQvQUQBDggQT4_HXyzT8Zo74JUF8cGkRlHkPmYPxBuM1xa1x42PNg0bn30sqIyuf9dv002HeAzv0Tq-/pubhtml?gid=1695127290&amp;single=true&amp;widget=true&amp;headers=false&amp;chrome=false&amp;rm=minimal"
      />
      
      <SheetTitle>Asset Class Diversification</SheetTitle>
      <Sheet 
        className="iframe-placeholder"
        height='486' 
        width='630'
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQvQUQBDggQT4_HXyzT8Zo74JUF8cGkRlHkPmYPxBuM1xa1x42PNg0bn30sqIyuf9dv002HeAzv0Tq-/pubhtml?gid=263247403&amp;single=true&amp;widget=true&amp;headers=false&amp;chrome=false&amp;rm=minimal"
      />

      <SheetTitle>Portfolio Statistics</SheetTitle>
      <Sheet 
        className="iframe-placeholder"
        height='2060' 
        width='706'
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQvQUQBDggQT4_HXyzT8Zo74JUF8cGkRlHkPmYPxBuM1xa1x42PNg0bn30sqIyuf9dv002HeAzv0Tq-/pubhtml?gid=612044188&amp;single=true&amp;widget=true&amp;headers=false&amp;chrome=false&amp;rm=minimal"
      />
    </SheetContainer>
  )
}

export default Analytics